export default __webpack_public_path__ + "static/media/image-hero.3de81110.jpg";